import { createSlice } from '@reduxjs/toolkit';
import {ResponseApi} from "../BaseApi";

const contractorSlice = createSlice({
    name: 'Contractor',
    initialState: {
        getByUserId: [],
        getUserDetailByUserId: [],
        getVehicleOnContractById: [],
        getEmployeOnContractById: [],
        getAllVehicleByContractor: [],

        // vehicle
        getVehicleFilter: [],
        contractorlistOfVehicles: [],
        getVehicleDetailById: [],
        getAllVehicleByContractorId: [],
        vehicleWorkOnContract: [],
        deleteEmployeeByContractAndUserList: null,
        deleteVehicleByContractAndVehicleList: null,
        getlistofcontractorEmployees: [],
        getlistofEmployeWorkOnContract: [],
        createToExternalVehicle: {},
        createVehicleAndRelationContractor: {},
        setToExternalVehicle: {},
        // Employe
        getAllGender: [],
        getAllEmployeeFilter: [],
        getEmployeByContractorId: [],
        getUserDetailForUpdate: [],

        // Documents
        getAllContractorDocuments: [],
        createContractorDocValue: {},
        setContractorDocValue: {},

        // employee
        getContractorsByUserId: {},

        // get contractor info for update
        getContractorInfoById: {},
    },
    reducers: {
        ClearGetContractorInfoById: (state, action) => {
            state.getContractorInfoById = {};
        },
    },
    extraReducers: {
        'contractor/GetByUserId/fulfilled': (state, action) => {
            state.getByUserId = ResponseApi(action.payload);
        },
        'contractor/GetUserDetailByUserId/fulfilled': (state, action) => {
            state.getUserDetailByUserId = ResponseApi(action.payload);
        },
        'contractor/GetUserExtraDetailByUserId/fulfilled': (state, action) => {
            state.getUserExtraDetailByUserId = ResponseApi(action.payload);
        },
        'contractor/GetVehicleOnContractById/fulfilled': (state, action) => {
            state.getVehicleOnContractById = ResponseApi(action.payload);
        },
        'contractor/getEmployeeOnContractById/fulfilled': (state, action) => {
            state.getEmployeOnContractById = ResponseApi(action.payload);
        },
        'contractor/GetAllVehicleByContractor/fulfilled': (state, action) => {
            state.getAllVehicleByContractor = ResponseApi(action.payload);
        },
        // Vehicle APi Response
        'contractor/GetVehicleFilter/fulfilled': (state, action) => {
            state.getVehicleFilter = ResponseApi(action.payload);
        },
        'contractor/contractorlistOfVehicles/fulfilled': (state, action) => {
            state.contractorlistOfVehicles = ResponseApi(action.payload);
        },
        'contractor/GetVehicleDetailById/fulfilled': (state, action) => {
            state.getVehicleDetailById = ResponseApi(action.payload);
        },
        'contractor/GetAllVehicleByContractorId/fulfilled': (state, action) => {
            state.getAllVehicleByContractorId = ResponseApi(action.payload);
        },
        'contractor/VehicleWorkOnContract/fulfilled': (state, action) => {
            state.vehicleWorkOnContract = ResponseApi(action.payload);
        },
        'contractor/deleteEmployeeByContractAndUserList/fulfilled': (state, action) => {
            state.deleteEmployeeByContractAndUserList = ResponseApi(action.payload);
        },
        'contractor/deleteVehicleByContractAndVehicleList/fulfilled': (state, action) => {
            state.deleteVehicleByContractAndVehicleList = ResponseApi(action.payload);
        },
        'contractor/GetlistofcontractorEmployees/fulfilled': (state, action) => {
            state.getlistofcontractorEmployees = ResponseApi(action.payload);
        },
        'contractor/GetlistofEmployeWorkOnContract/fulfilled': (state, action) => {
            state.getlistofEmployeWorkOnContract = ResponseApi(action.payload);
        },
        'contractor/createToExternalVehicle/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.createToExternalVehicle = data;
            }
        },
        'contractor/createVehicleAndRelationContractor/fulfilled': (state, action) => {
            state.createVehicleAndRelationContractor = ResponseApi(action.payload);
        },
        'contractor/setToExternalVehicle/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.setToExternalVehicle = data;
            }
        },
        // Employee Api
        'contractor/GetAllGender/fulfilled': (state, action) => {
            state.getAllGender = ResponseApi(action.payload);
        },
        'contractor/GetAllEmployeeFilter/fulfilled': (state, action) => {
            state.getAllEmployeeFilter = ResponseApi(action.payload);
        },
        'contractor/GetUserDetailForUpdate/fulfilled': (state, action) => {
            state.getUserDetailForUpdate = ResponseApi(action.payload);
        },
        'contractor/getAllContractorDocuments/fulfilled': (state, action) => {
            state.getAllContractorDocuments = ResponseApi(action.payload);
        },
        'contractor/setContractorDocValue/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};

            if (status >= 200 && status < 300) {
                state.setContractorDocValue = data;
            }
        },
        'contractor/createContractorDocValue/fulfilled': (state, action) => {
            state.createContractorDocValue = ResponseApi(action.payload);
        },

        // get contractor by id
        'contractor/getContractorsByUserId/fulfilled': (state, action) => {
            state.getContractorsByUserId = ResponseApi(action.payload);
        },
        // get contractor employee details
        'contractor/getContractorEmployeeDetail/fulfilled': (state, action) => {
            state.getContractorEmployeeDetail = ResponseApi(action.payload);
        },
        // get contractor status
        'contractor/getContractorInfoById/fulfilled': (state, action) => {
            state.getContractorInfoById = ResponseApi(action.payload);
        },
    },
});

export const { customScduleTime } = contractorSlice.actions;
export const byUserId = (state) => state.ContractorSlice.getByUserId;
export const userDetailByUserId = (state) => state.ContractorSlice.getUserDetailByUserId;
export const userExtraDetailByUserId = (state) => state.ContractorSlice.getUserExtraDetailByUserId;
export const activeContarcts = (state) => state.ContractorSlice.getActiveContracts;
export const vehicleOnContractById = (state) => state.ContractorSlice.getVehicleOnContractById;
export const employeOnContractById = (state) => state.ContractorSlice.getEmployeOnContractById;
export const allVehicleByContractor = (state) => state.ContractorSlice.getAllVehicleByContractor;

// Vehicle APi
export const vehicleFilter = (state) => state.ContractorSlice.getVehicleFilter;
export const vehicleByContractorId = (state) => state.ContractorSlice.getVehicleByContractorId;
export const vehicleDetailById = (state) => state.ContractorSlice.getVehicleDetailById;
export const vehicleStatus = (state) => state.ContractorSlice.getVehicleStatus;
export const allVehicleByContractorId = (state) => state.ContractorSlice.getAllVehicleByContractorId;
export const allvehicleWorkOnContract = (state) => state.ContractorSlice.vehicleWorkOnContract;
export const deleteEmployeeByContractAndUserList = (state) => state.ContractorSlice.deleteEmployeeByContractAndUserList;
export const deleteVehicleByContractAndVehicleList = (state) =>
    state.ContractorSlice.deleteVehicleByContractAndVehicleList;
export const listofcontractorEmployees = (state) => state.ContractorSlice.getlistofcontractorEmployees;
export const listofEmployeWorkOnContract = (state) => state.ContractorSlice.getlistofEmployeWorkOnContract;

// Employee APi

export const allGender = (state) => state.ContractorSlice.getAllGender;
export const allEmployeeFilter = (state) => state.ContractorSlice.getAllEmployeeFilter;
export const employeByContractorId = (state) => state.ContractorSlice.getEmployeByContractorId;
export const userStatus = (state) => state.ContractorSlice.getUserStatus;
export const userDetailForUpdate = (state) => state.ContractorSlice.getUserDetailForUpdate;
// Documents
export const allContractorDocuments = (state) => state.ContractorSlice.getAllContractorDocuments;

export const { ClearGetContractorInfoById } = contractorSlice.actions;

export default contractorSlice.reducer;
